module.exports = __webpack_public_path__ + "static/img/bg-overview@t.19a11a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/samsung-svc/bg-overview@t.jpg
// module id = U9f+
// module chunks = 0